define('vspot-angular/services/googlerecaptcha-service',['vspot-user'], function (googleReCaptcha) {
    'use strict';
    
    return ['resources.User', function (googleReCaptcha) {
        require(['googleReCaptcha']);
        return {
            verifyGoogleReCaptcha : function(res, callback) {
                    callback(res);
            }
        };
    }];
});

